export const THIEN_CAN_ORDER = [
  'Giap', 'At', 'Binh', 'Dinh', 'Mau',
  'Ky', 'Canh', 'Tan', 'Nham', 'Quy'
];

export const DIA_CHI_ORDER = [
  'Ty', 'Suu', 'Dan', 'Mao', 'Thin', 'Ty_',
  'Ngo', 'Mui', 'Than', 'Dau', 'Tuat', 'Hoi'
];

// Reference anchor: 1984 (Giáp Tý) per common BaZi convention.
// Formula equivalent: can = (year - 4) mod 10, chi = (year - 4) mod 12.
export function getCanChiYear(year) {
  const mod = (value, divisor) => ((value % divisor) + divisor) % divisor;
  const canIndex = mod(year - 4, 10);
  const chiIndex = mod(year - 4, 12);

  return {
    year,
    canIndex,
    chiIndex,
    can: THIEN_CAN_ORDER[canIndex],
    chi: DIA_CHI_ORDER[chiIndex],
    label: `${THIEN_CAN_ORDER[canIndex]} ${DIA_CHI_ORDER[chiIndex]}`
  };
}
